let backendHost;

const hostname = process.env.REACT_APP_HOSTNAME ?? window?.location?.hostname;

if (hostname.indexOf("localhost") < 0) backendHost = process.env.REACT_APP_API_URL;
else backendHost = "http://localhost:8080";

// PLEASE DON'T EDIT THIS FROM HERE, USE .env FILE INSTEAD
backendHost = process.env.REACT_APP_API_URL;

export const API_ROOT = `${backendHost}/api`;
export const BACKEND_HOST = backendHost;
